import * as React from 'react';
import { styled } from '@glitz/react';
import { createMinMediumViewportDecorator } from 'webapp/viewport';
import { Document } from '@avensia/excite-contentful';
import { scrollbarDecorator } from 'webapp/decorators/scrollbar';
import { edgeMarginsDecorator, maxContentNarrowWidthDecorator } from 'webapp/components/page-layout';

type PropType = {
  title?: string;
  description?: Excite.Contentful.DocumentApiModel;
};

export default function AdditionalContent(props: PropType) {
  const { title, description } = props;
  return (
    <Base>
      {title ? <Title>{title}</Title> : null}
      {description ? (
        <Description>
          <Document elements={description.elements} />
        </Description>
      ) : null}
    </Base>
  );
}

const Title = styled.h4(createMinMediumViewportDecorator({ textTransform: 'none' }), {
  fontSize: t => t.fontSize.s,
  fontWeight: t => t.fontWeight?.bold,
  textTransform: 'uppercase',
  marginBottom: t => t.spacing.l,
});

const Description = styled.div({
  marginBottom: t => t.spacing.m,
  fontSize: t => t.fontSize.xs,
});

const Base = styled.div(
  maxContentNarrowWidthDecorator,
  edgeMarginsDecorator,
  scrollbarDecorator,
  createMinMediumViewportDecorator({
    maxHeight: 1200,
  }),
  {
    maxHeight: 250,
    width: 'auto',
    overflowY: 'auto',
  },
);
